// iOS-like Page Transition using Framer Motion in TypeScript
// - Add proper typings for props and event handlers
// - Close button also triggers slide-out animation

import { AnimatePresence, motion, PanInfo, Transition } from 'framer-motion';
import { ReactNode, useState } from 'react';

const iosSpring: Transition = {
    type: 'spring',
    stiffness: 320,
    damping: 30,
    mass: 0.9,
};

interface IOSPageProps {
    isActive: boolean;
    onBackSwipe?: () => void;
    children: ReactNode;
}

export function IOSPage({ isActive, onBackSwipe, children }: IOSPageProps) {
    const [canDrag, setCanDrag] = useState(false);

    return (
        <AnimatePresence initial={false}>
            {isActive && (
                <motion.div
                    key="ios-page"
                    className="fixed inset-0 overflow-hidden  z-[9999]"
                    initial={{ x: '100%', opacity: 1 }}
                    animate={{
                        x: 0,
                        opacity: 1,
                        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                    }}
                    exit={{ x: '100%', opacity: 0 }}
                    transition={iosSpring}
                    drag={canDrag ? 'x' : false}
                    dragConstraints={{ left: 0, right: 0 }}
                    dragElastic={{ left: 0.2, right: 0 }}
                    onDragEnd={(e: MouseEvent | TouchEvent, info: PanInfo) => {
                        if (info.offset.x > 80) {
                            onBackSwipe?.();
                        }
                    }}
                    onPointerDown={(e) => {
                        if (e.clientX <= 24) setCanDrag(true);
                        else setCanDrag(false);
                    }}
                    // style={{ background: 'white', borderRadius: 0 }}
                >
                    <div className="h-full">{children}</div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export function UnderPage({ children }: { children: ReactNode }) {
    return (
        <motion.div
            className=" overflow-auto"
            initial={{ opacity: 1 }}
            animate={{ opacity: 0.95 }}
            exit={{ opacity: 1 }}
            transition={{ duration: 0.25 }}
            // style={{ background: '#f7f7f8', willChange: 'opacity' }}
        >
            {children}
        </motion.div>
    );
}
